<template>
    <div id="section-1" class="slide mb-8
            pb-8
            md:mb-16 md:pb-16
            ">
        <section class="
        md:pt-[90px]  md:px-[50px] relative
        md:pb-[24px]
    ">
            <div
                class=" relative min-h-screen md:min-h-full  flex md:block flex-col justify-center mt-[-100px] md:mt-0  ">
                <div class=" text-grayDark  ">
                    <div class="">
                        <div class="z-10">
                            <div class="flex flex-col"></div>
                            <div class="title-42 md:title-68 flex flex-col">
                                <div class="hero-title-animation order-first" :key="sliderKey">
                                    <div>
                                        <div>
                                            <div class="title md:pb-1 " tabindex="-1"
                                                 style="width:100%;display:inline-block">Ready
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div>
                                            <div class="title md:pb-1" tabindex="-1"
                                                 style="width:100%;display:inline-block">Moved
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span><h1 class="title">to be your New Trademark Lawyers</h1></span>
                            </div>
                        </div>
                        <p class="title-2 mt-2 md:mb-0 md:mt-3 span-20 md:span-26">We’re a team of expert trademark attorneys who specialize in Trademark Prosecution, Administrative Litigation, and Ex Parte Appeals.</p>
                        <div class="hidden md:block">
                            <div
                                class="flex flex-col mt-6 md:mt-[28px] space-y-[16px] md:flex-row md:space-x-4 md:space-y-0">
                                <div><a class="md:text-left cta null undefined" onclick="Chatra('openChat', true)">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                         class="inline mr-2 h-[18px] w-[18px]   ">
                                        <path
                                            d="M4 11.0001V13.0001H16L12.5 16.5001L13.92 17.9201L19.84 12.0001L13.92 6.08008L12.5 7.50008L16 11.0001H4Z"></path>
                                    </svg>
                                    <span class="white-text">Request a Call</span></a></div>
                                <div>
                                    <div @click="toRegistration" class="md:text-left cta cta-white undefined">
                                        <svg width="24" height="24" viewBox="0 0 24 24"
                                             xmlns="http://www.w3.org/2000/svg" class="inline mr-2 h-[18px] w-[18px]">
                                            <path
                                                d="M10 16.5L16 12L10 7.5V16.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"></path>
                                        </svg>
                                        <span>Trademark Registration</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bg-white block md:hidden order-3 z-10">
                    <div class="flex flex-col mt-6 md:mt-[28px] space-y-[16px] md:flex-row md:space-x-4 md:space-y-0">
                        <div><a class="md:text-left cta null undefined" onclick="Chatra('openChat', true)">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                                 class="inline mr-2 h-[18px] w-[18px]   ">
                                <path
                                    d="M4 11.0001V13.0001H16L12.5 16.5001L13.92 17.9201L19.84 12.0001L13.92 6.08008L12.5 7.50008L16 11.0001H4Z"></path>
                            </svg>
                            <span class="white-text">Request a Call</span></a></div>
                        <div>
                            <div @click="toRegistration" class="md:text-left cta cta-white undefined">
                                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                                     class="inline mr-2 h-[18px] w-[18px]">
                                    <path
                                        d="M10 16.5L16 12L10 7.5V16.5ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"></path>
                                </svg>
                                <span>Trademark Registration</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
import jQuery from "jquery";
import {slick} from "@/helper";
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref } from "vue";

const sliderKey = ref(1)

onMounted(() => {
    sliderKey.value++

    slick()

    $(document).ready(function() {
        $('.hero-title-animation').slick({
            infinite: true,
            vertical: true,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    });
});
const router = useRouter()

function toRegistration () {
    router.push({ path: 'trademark-registration-process' })
}

</script>
<style>
.slick-list.draggable {
    overflow: hidden;
}
.slider-inner, .slick-prev, .slick-next {
    display: none!important;
}
</style>
<style scoped>
@font-face {
    font-family: Kanit;
    font-style: normal;
    font-weight: 200;
    font-display: swap;
    src: url(@/fonts/3a300a8b42167374-s.p.woff2) format("woff2");
}
@font-face {
    font-family: Kanit;
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(@/fonts/1de9c871cd3a3669-s.p.woff2) format("woff2");
}
@font-face {
    font-family: Kanit;
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url(@/fonts/67be4c401af36c57-s.p.woff2) format("woff2");
}
@font-face {
    font-family: Kanit;
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url(@/fonts/de69c930925b36eb-s.p.woff2) format("woff2");
}
.title {
    font-family: Kanit;
    font-size: 68px!important;
    font-weight: bold;
    line-height: 68px!important;
    color: #242426!important;
}
.title-2 {
    font-family: Kanit;
    font-size: 26px!important;
    font-weight: 400;
    line-height: 33px!important;
    color: #242426!important;
}
span {
    font-family: Kanit;
}
.white-text {
    color: #fdfdfe!important;
}
/*! CSS Used from: https://www.questel.com/_next/static/css/954c5de3f9bf1fcc.css */
*,:after,:before{box-sizing:border-box;border:0 solid #e5e7eb;}
:after,:before{--tw-content:"";}
h1{font-size:inherit;font-weight:inherit;}
a{color:inherit;text-decoration:inherit;}
h1,p{margin:0;}
:disabled{cursor:default;}
svg{display:block;vertical-align:middle;}
*,:after,:before{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-scroll-snap-strictness:proximity;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;}
.relative{position:relative;}
.z-10{z-index:10;}
.order-3{order:3;}
.order-first{order:-9999;}
.mb-8{margin-bottom:2rem;}
.mr-2{margin-right:.5rem;}
.mt-2{margin-top:.5rem;}
.mt-6{margin-top:1.5rem;}
.mt-\[-100px\]{margin-top:-100px;}
.block{display:block;}
.inline{display:inline;}
.flex{display:flex;}
.hidden{display:none;}
.h-\[18px\]{height:18px;}
.min-h-screen{min-height:100vh;}
.w-\[18px\]{width:18px;}
.flex-col{flex-direction:column;}
.justify-center{justify-content:center;}
.space-y-\[16px\]>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(16px * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(16px * var(--tw-space-y-reverse));}
.bg-white{--tw-bg-opacity:1;background-color:rgb(253 253 254/var(--tw-bg-opacity));}
.pb-8{padding-bottom:2rem;}
.text-grayDark{--tw-text-opacity:1;color:rgb(36 36 38/var(--tw-text-opacity));}
.title-42{font-size:42px;font-weight:600;line-height:110%;}
.span-20{font-size:20px;font-weight:400;line-height:140%;}

.cta {
    box-sizing: border-box;
    display: inline-block;
    width: 100%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    border-radius: .5rem;
    border-width: 2px;
    fill: #fdfdfe;
    padding: 12px 20px;
    text-align: center;
    --tw-text-opacity: 1;
    color: rgb(253 253 254/var(--tw-text-opacity));
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    --tw-bg-opacity: 1;
    background-color: #14BCC3;
    border-color: #14BCC3;
}

.cta,.cta:hover{--tw-border-opacity:1;}

.cta:hover {
    border-color: #14BCC3;
    color: #14BCC3!important;
    --tw-bg-opacity: 1;
    fill: #14BCC3;
    background-color: #fff;
    box-shadow: 0 15px 30px rgba(0, 0, 0, .22);
    text-decoration: none;
}
.cta:hover .white-text{
    color: #14BCC3!important;
}

@media (min-width:768px){
    .cta{justify-content:flex-start;width:-moz-fit-content;width:fit-content;}
}

@media (max-width:768px){
    #section-1 {
        margin-top: 100px!important;
    }
}

#section-1 {
    margin-top: 128px;
    margin-bottom: 40px;
    padding-bottom: 0;
}

.cta-white {
    background-color: transparent;
    fill: #14BCC3;
    border-color: #14BCC3;
    color: #14BCC3;
}

.cta-white,.cta-white:hover{--tw-border-opacity:1;--tw-text-opacity:1;}

.cta-white:hover {
    border-color: #14BCC3;
    background-color: #14BCC3;
    fill: #fff;
    color: #fff!important;
}

*{font-display:swap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-smoothing:antialiased;text-rendering:geometricPrecision;}
section{margin-left:auto;margin-right:auto;width:100%;}
a,a path,a span{transition-property:all;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);}
.hero-title-animation .slick-slide+.slick-cloned,.hero-title-animation .slick-slide.slick-current{background-image:none!important;}
@media (min-width:768px){
    .md\:mb-0{margin-bottom:0;}
    .md\:mb-16{margin-bottom:4rem;}
    .md\:mt-0{margin-top:0;}
    .md\:mt-3{margin-top:.75rem;}
    .md\:mt-\[28px\]{margin-top:28px;}
    .md\:block{display:block;}
    .md\:hidden{display:none;}
    .md\:min-h-full{min-height:100%;}
    .md\:flex-row{flex-direction:row;}
    .md\:space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)));}
    .md\:space-y-0>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0px * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0px * var(--tw-space-y-reverse));}
    .md\:px-\[50px\]{padding-left:50px;padding-right:50px;}

    .md\:pb-16{padding-bottom:4rem;}
    .md\:pb-\[24px\]{padding-bottom:24px;}
    .md\:pt-\[90px\]{padding-top:90px;}
    .md\:text-left{text-align:left;}
    .md\:title-68{font-size:68px;font-weight:600;line-height:100%;}
    .md\:span-26{font-size:26px;font-weight:400;line-height:125%;}
}
.md\:pb-1{padding-bottom:.25rem;}
/*! CSS Used from: Embedded */
.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;touch-action:pan-y;-webkit-tap-highlight-color:transparent;}
.slick-list,.slick-slider{position:relative;display:block;}
.slick-list{overflow:hidden;margin:0;padding:0;}
.slick-list:focus{outline:none;}
.slick-slider .slick-list,.slick-slider .slick-track{transform:translateZ(0);}
.slick-track{position:relative;top:0;left:0;display:block;margin-left:auto;margin-right:auto;}
.slick-track:after,.slick-track:before{display:table;content:"";}
.slick-track:after{clear:both;}
.slick-slide{display:none;float:left;height:100%;min-height:1px;}
.slick-initialized .slick-slide{display:block;}
.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent;}
</style>
